module.exports = __webpack_public_path__ + "static/media/payment.d6ca2afe.svg";